// extracted by mini-css-extract-plugin
export default {"title":"Products_title__MOtgj","description":"Products_description__+y7mt","card":"Products_card__LVYK6"};